var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('p',[_vm._v(_vm._s(_vm.$t('our_email'))+" "),_c('a',{attrs:{"href":"adomany@akasapjt.hu"}},[_vm._v("adomany@akasapjt.hu")])])])}
var staticRenderFns = []

export { render, staticRenderFns }